import { defineStore } from 'pinia'

import {
    generateRecoveryCodes,
    getAuth2faMethods,
    getRecoveryCodes,
    sendDisable2faVerificationCode,
    sendEnable2faVerificationCode,
    sendEnableAuth2faMethod,
    remindLater,
} from '@/api/auth-routes'

import { useDefaultStore } from '@/store/defaultStore'
import { useAuthorizationStore } from '@/store/authorizationStore'

export const useTwoFactorAuthentication = defineStore('twoFactorAuthentication', {
    state: () => ({
        loading: false,
        actionLoading: false,
        methodLoading: false,

        currentMethod: {},
        itemsMethods: [],
        itemsCode: [],

        qrCode: null,
        secretCode: null,

        showConfirmDialog: false,
    }),

    actions: {
        setConfirmDialogVisible(showConfirmDialog) {
            this.showConfirmDialog = showConfirmDialog
        },

        updateCurrentMethod(method) {
            this.currentMethod = method
        },

        async goToLoadAuth2faMethods() {
            this.loading = true

            const { success, message, payload } = await getAuth2faMethods()

            if (success) {
                this.itemsMethods = payload
            } else {
                const defaultStore = useDefaultStore()
                defaultStore.setErrorMessage({ message })
            }

            this.loading = false
        },

        async goToLoadRecoveryCodes() {
            this.loading = true

            const { success, message, payload } = await getRecoveryCodes()

            if (success) {
                this.itemsCode = payload
            } else {
                const defaultStore = useDefaultStore()
                defaultStore.setErrorMessage({ message })
            }

            this.loading = false
        },

        async goToRegenerateCode() {
            this.actionLoading = true

            const { success, message, payload } = await generateRecoveryCodes()

            if (success) {
                this.itemsCode = payload
            } else {
                const defaultStore = useDefaultStore()
                defaultStore.setErrorMessage({ message })
            }

            this.actionLoading = false
        },

        async goToEnableAuth2faMethod(id) {
            const defaultStore = useDefaultStore()

            this.methodLoading = true

            const { success, message, payload } = await sendEnableAuth2faMethod(id)

            if (success) {
                const { qr_code_svg, secret } = payload
                this.qrCode = qr_code_svg
                this.secretCode = secret

                defaultStore.setSuccessMessage({ message })
            } else {
                defaultStore.setErrorMessage({ message })
            }

            this.methodLoading = false

            return { success }
        },

        async goToEnable2faVerificationCode(code) {
            const defaultStore = useDefaultStore()

            this.actionLoading = true

            const { success, message } = await sendEnable2faVerificationCode({
                methodId: this.currentMethod,
                formData: {
                    input: code,
                },
            })

            if (success) {
                const authorizationStore = useAuthorizationStore()

                await authorizationStore.getCheckUserAccess()
                defaultStore.setSuccessMessage({ message })
            } else {
                defaultStore.setErrorMessage({ message })
            }

            this.actionLoading = false

            return { success }
        },

        async goToDisable2faVerificationCode(body) {
            const defaultStore = useDefaultStore()

            this.actionLoading = true

            const { success, message } = await sendDisable2faVerificationCode(body)

            if (success) {
                const authorizationStore = useAuthorizationStore()

                this.qrCode = null

                await authorizationStore.getCheckUserAccess()
                defaultStore.setSuccessMessage({ message })
            } else {
                defaultStore.setErrorMessage({ message })
            }

            this.actionLoading = false

            return { success }
        },

        async goToRemindLater() {
            this.actionLoading = true

            const { success, message } = await remindLater()

            if (!success) {
                const defaultStore = useDefaultStore()
                defaultStore.setErrorMessage({ message })
            }

            this.actionLoading = false

            return { success }
        },
    },
})
